<div #banner [hidden]="!currentBanner" class="banner" [ngStyle]="currentBannerStyle">
    <div class="banner-content">
        <div class="banner-graphic-text-wrapper">
            <div class="banner-icon" *ngIf="currentBanner && currentBanner.icon">
                <button mat-icon-button (click)="doBannerAction()">
                    <mat-icon [ngStyle]="color" color="primary">{{currentBanner.icon}}</mat-icon>
                </button>
            </div>
            <div class="banner-text">
                <ng-template class="banner-text" casBannerContent></ng-template>
            </div>
        </div>
        <div class="banner-actions">
            <div class="spacer"></div>
            <button *ngIf="currentBanner && currentBanner.actionButtonText" [ngStyle]="color" mat-button (click)="doBannerAction()" color="primary">
                {{currentBanner.actionButtonText}}
            </button>
            <button
                *ngIf="currentBanner && currentBanner.closeButtonText"
                [ngStyle]="color"
                class="btn-right"
                mat-button
                (click)="closeCurrentBanner()"
                color="primary"
            >
                {{currentBanner.closeButtonText}}
            </button>
        </div>
    </div>
</div>
